import React from 'react';
import { PiNotePencilBold } from 'react-icons/pi';
import PersonRemoveAlt1OutlinedIcon from '@mui/icons-material/PersonRemoveAlt1Outlined';
import { Button, Stack, Typography } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';

import type { User } from 'src/types/user';

export const useUserListColumns = (
  t: any,
  goToDetail: (id: number) => void,
  handleRemoveUser: (userId: string) => Promise<void>,
  currentUser?: User | false,
): GridColDef[] => [
  {
    field: 'first_name',
    flex: 2,
    headerName: t('List.FirstName'),
    minWidth: 100,
    sortable: true,
    renderHeader: () => <Typography>{t('List.FirstName')}</Typography>,
    renderCell: (params) => (
      <Typography variant="body1">{params.row?.first_name ?? '-'}</Typography>
    ),
  },
  {
    field: 'last_name',
    flex: 2,
    headerName: t('List.LastName'),
    minWidth: 100,
    sortable: true,
    renderHeader: () => <Typography>{t('List.LastName')}</Typography>,
    renderCell: (params) => (
      <Typography variant="body1">{params.row?.last_name ?? '-'}</Typography>
    ),
  },
  {
    field: 'email',
    flex: 3,
    headerName: t('List.Email'),
    minWidth: 100,
    sortable: true,
    renderHeader: () => <Typography>{t('List.Email')}</Typography>,
    renderCell: (params) => (
      <Typography variant="body1">{params.row?.email ?? '-'}</Typography>
    ),
  },
  {
    field: 'business_unit',
    flex: 2,
    headerName: t('List.BusinessUnit'),
    minWidth: 100,
    sortable: true,
    renderHeader: () => <Typography>{t('List.BusinessUnit')}</Typography>,
    renderCell: (params) => (
      <Typography variant="body1">
        {params.row?.business_unit?.name ?? '-'}
      </Typography>
    ),
  },
  {
    field: 'id',
    headerName: '',
    flex: 1,
    minWidth: 100,
    sortable: false,
    renderCell: (params) => (
      <Stack
        direction="row"
        spacing={1}
        sx={{
          py: 1,
        }}
      >
        <Button
          variant="squareCta"
          color="secondary"
          data-test-id={`user-admin-edit-button-${params.value}`}
          disabled={currentUser && currentUser.id === params.value}
          onClick={() => goToDetail(params.value)}
          size="small"
        >
          <PiNotePencilBold size={23} />
        </Button>
        <Button
          variant="squareCta"
          color="secondary"
          data-test-id={`user-admin-remove-button-${params.value}`}
          disabled={currentUser && currentUser.id === params.value}
          onClick={() => handleRemoveUser(params.value)}
          size="small"
        >
          <PersonRemoveAlt1OutlinedIcon />
        </Button>
      </Stack>
    ),
  },
];
